<template>
    <div class="g-scroll">
        <mt-loadmore :top-method="loadTop" ref="loadmore">
          <div class="g-page-scroll">
            <ul  
                v-infinite-scroll="loadMore" 
                infinite-scroll-disabled="infiniteScrollDisabled" 
                infinite-scroll-distance="10"
                :infinite-scroll-immediate-check="infiniteScrollImmediateCheck"
            >
            <li v-for="(item, index) in list" :key="index">
              <slot
                :index="index"
                :data="item"
              >
              </slot>
            </li>
            <li class="g-nodata-wrap" v-if="nodata">
              <img 
                :src="require('@img/nodata.png')" alt="" class="g-nodata" 
                >
              <p>您还没有数据哦~</p>
            </li>
            </ul>
          </div>
        </mt-loadmore>
    </div>
</template>
<script>
import { Loadmore, InfiniteScroll } from 'mint-ui';
export default {
  name: 'VScroll',
  props: {
    infiniteScrollDisabled: '',
    infiniteScrollImmediateCheck: true,
    list: Array,
    nodata: Boolean
  },
  methods: {
    loadTop () {
      this.$emit('loadTop');
      this.$refs.loadmore.onTopLoaded();
    },
    loadMore () {
      this.$emit('loadMore');
    }
  },
  components: {
    Loadmore,
    InfiniteScroll
  }
};
</script>

<style lang="scss">
.g-scroll {
  .g-page-scroll {
    .g-nodata-wrap {
      width: 100%;
      text-align: center;
      padding: 20px 0;
      color: #666;
      .g-nodata {
        width: 150px;
        padding: 5px 0;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/base/scroll.vue